import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { CerrixIcon } from "@app/shared/models/CerrixIconModel";
import { SafePipe } from "@app/shared/pipes/safe.pipe";
import { SelectableIcons } from "@constants/selectableicons";
import { parseTyped } from "@methods/CommonMethods";

@Component({
    selector: "app-cerrix-tree-icon-viewer",
    templateUrl: "./cerrix-tree-icon-viewer.component.html",
    styleUrls: ["./cerrix-tree-icon-viewer.component.scss"],
    imports: [SafePipe],
})
export class CerrixTreeIconViewerComponent implements OnInit, OnChanges {
    @Input() icon: string;
    @Input() appendClass: string;
    @Input() defaultColor = "#000000";

    iconName: string;
    selector: string;
    animated: boolean;
    bordered: boolean;
    color: string;

    constructor() {}

    ngOnInit() {
        this.reload(this.icon);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.icon.currentValue !== changes.icon.previousValue) {
            this.reload(this.icon);
        }
    }

    reload(value: string) {
        const parsed = parseTyped<CerrixIcon>(value, {
            iconName: "",
            selector: value,
            animate: false,
            border: false,
            color: this.defaultColor,
        });
        this.iconName = parsed.iconName;
        this.selector = parsed.selector;
        this.animated = parsed.animate;
        this.bordered = parsed.border;
        this.color = parsed.color;

        if (!this.iconName) {
            const foundIcon = SelectableIcons.icons.find((x) => x.selector === this.selector);
            if (foundIcon) {
                this.iconName = foundIcon.name;
            }
        }
    }
}
